'use strict';

const scriptUrlPathFromFileName = (fileName, urlTemplate) => urlTemplate.replace('-ASSET_RESOURCE-',fileName);
const styleUrlPathFromFileName = (fileName, urlTemplate) => urlTemplate.replace('-ASSET_RESOURCE-',fileName);

// ------ DATE PICKER ------
const monthMap = {
  "ene" : 1,
  "feb" : 2,
  "mar" : 3,
  "abr" : 4,
  "may" : 5,
  "jun" : 6,
  "jul" : 7,
  "ago" : 8,
  "sep" : 9,
  "oct" : 10,
  "nov" : 11,
  "dic" : 12 
}
  
function parseDate(date) {
  const parsedDate = new Date(date);
  if(!isNaN(parsedDate)) {
    return parsedDate
  }

  var [day, month, year, hour] = date.replaceAll(' de', '').split(' ')
  if(!day || !month || !year) {
    return
  }
  month = monthMap[month.substring(0,3)]
  return new Date(`${year}/${month}/${day} ${hour || "00:00"}`)
}


function loadScriptAsync(url) {
  const script = document.createElement('script')
  script.src = url
  script.async = true
  document.body.appendChild(script)
}

function loadLink(url) {
  const link = document.createElement('link')
  link.rel = 'stylesheet'
  link.href = url
  document.body.appendChild(link)
}
  
((globalConfig) => {

  const scriptFileNameFromFeature = (feature) => `ait-${feature}-script-index.js`
  const styleFileNameFromFeature = (feature) => `ait-${feature}-style-main.css`
  const scriptUrlPathFromFeature = (feature) => scriptUrlPathFromFileName(scriptFileNameFromFeature(feature), globalConfig.asset_url_template)
  const styleUrlPathFromFeature = (feature) => styleUrlPathFromFileName(styleFileNameFromFeature(feature), globalConfig.asset_url_template)
  
  const featureFromPath = (path) => path.split('/')[1]

  function init() { 
    const feature = featureFromPath(window.location.pathname)
    if (!feature) return

    loadLink(styleUrlPathFromFeature(feature))
    loadScriptAsync(scriptUrlPathFromFeature(feature))
  }

  init(globalConfig)

})(globalConfig)